import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, switchMap, tap } from "rxjs";
import { ConfigService } from "src/app/core/config/config-service";
import { Imports } from "../models/imports";
import { ImportDiscardOption } from "../enums/import-discard-option.enum";
import { ImportState } from "../enums/import-state.enum";

@Injectable({ providedIn: 'root' })
export class ImportsService {
    constructor(private http: HttpClient, private configService: ConfigService) { }

    private get baseUrl(): string {
        return `${this.configService.getUrlVendorCatalogApi()}/imports`;
    }

    fetchImports(vendorId?: number, clientId?: number, importStates?: ImportState[], page: number = 0, size: number = 10, sort?: string): Observable<{ items: Imports[]; totalCount: number }> {
        var url = this.baseUrl;

        let httpParams = new HttpParams()
            .set('vendorId', vendorId ?? -99999)
            .set('clientId', clientId ?? -99999)
            .set('page', page ?? 0)
            .set('size', size ?? 10)
            .set('sort', (sort ?? '').toString());

        importStates?.forEach(state => {
            httpParams = httpParams.append('importStates', state);
        });

        return this.http.get<{ items: Imports[]; totalCount: number }>(url, { params: httpParams });
    }

    discardImport(importId: number, discardOption: ImportDiscardOption): Observable<void> {
        return this.http.patch<void>(`${this.baseUrl}/${importId}`, discardOption );
    }

    uploadImportFile(formData: FormData): Observable<void> {
        let csrfToken: string | undefined;
        return this.getAntiForgeryToken().pipe(
            tap(token => {
                csrfToken = token;
            }),
            switchMap(token => {
                const headers = new HttpHeaders().set('RequestVerificationToken', token);
                return this.http.post<void>(`${this.baseUrl}/manual`, formData, { headers, withCredentials: true });
            })
        );
    }

    // holen eines Anti-Forgery Tokens
    private getAntiForgeryToken(): Observable<string> {
        var url = this.configService.getUrlVendorCatalogApi() + '/api/antiforgery-token';
        return this.http.get<{ token: string }>(url, { withCredentials: true }).pipe(            switchMap(response => [response.token])
        );
    }

    fetchImportById(importId: number) {
        return this.http.get<Imports>(`${this.baseUrl}/${importId}`);
    }

    resetImport(importId: number) {
        return this.http.post<void>(`${this.baseUrl}/${importId}/reset`, null);
    }
}